'use strict';

import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import SecureLs from 'secure-ls';
import {APP_TONS} from '../config/constanst.config';

import createdPersistedState from 'vuex-persistedstate';

/*const ls = new SecureLs(
    {
      encodingType: 'aes',
      isCompression: false,
      encryptionSecret: APP_TONS.ENCRYPTED_SECRET,
    },
);*/

Vue.use(Vuex);

//test naming convention for modules.
console.log(modules);

export default new Vuex.Store({

  /** global state **/
  state: {
    isLoading: false,
    counts: [10, 20, 30, 40, 50, 100, 200],
  },

  /** global module **/
  modules,

  /** global mutations **/
  mutations: {
    set_is_loading(state, payload) {
      state.isLoading = payload;
    },
  },

  /** global getters **/
  getters: {
    isLoading: state => state.isLoading,
    counts: state => state.counts,
  },

  //https://www.npmjs.com/package/vuex-persistedstate
  plugins: [
    createdPersistedState({
      key: APP_TONS.ENCRYPTED_DATA,
      paths: [
        'auth.authUser',
        'auth.authPos',
        'auth.authUserSystems',
        'vessel.formData',
        'vessel.vessels',
        'vessel.vesselDetails',
        'vessel.vesselTonRanks',
        'crewtonremark.crewTonRemark',
        'crewtonremark.crewTonRemarks',
        'user.user',

        'pagination.vesselPagination',

        //keys
        'objectkey.objRankKeys',
        'objectkey.objManningKeys',
        'objectkey.objVesselTypeKeys',
        'objectkey.objVesselKeys',
        'objectkey.objCrewKeys',
        'objectkey.objRankKeys',

        'crewton.crewTon',
        'crewton.formDataVesselTon',
        'crewton.formTonPayload',
      ],
      /*storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },*/
      storage: window.localStorage,
    }),
  ],
});
